import { Directive, Input, ElementRef, HostListener } from '@angular/core';

// Code pris sur https://github.com/CoderAjay/ng2Draggable/blob/master/ng2-draggable.ts
// CHANGEMENT des EVENT des drag en mouseEvent qui apporte plus de fluidité

@Directive({
    selector: '[draggable]'
})
export class DraggableDirective {

    private _topStart: number;
    private _leftStart: number;
    private _allowDrag: boolean;
    private md: boolean;

    constructor(public element: ElementRef) {
        this._topStart = 0;
        this._leftStart = 0;
        this._allowDrag = true;
    }


    @HostListener('mousedown', ['$event'])
    public onMouseDown(event: MouseEvent) {
        this.md = true;
        this._topStart = event.clientY - this.element.nativeElement.parentElement.offsetTop;
        this._leftStart = event.clientX - this.element.nativeElement.parentElement.offsetLeft;
    }

    @HostListener('window:resize')
    public onResize(event: MouseEvent) {
        this.stickToViewport();
    }

    @HostListener('document:mouseup')
    public onMouseUp(event: MouseEvent) {
        this.md = false;
        this.stickToViewport();
    }

    @HostListener('document:mousemove', ['$event'])
    public onMouseMove(event: MouseEvent) {
        if (this.md && this._allowDrag) {

            if ((event.clientY - this._topStart) !== 0) {
                this.element.nativeElement.parentElement.style.top = (event.clientY - this._topStart) + 'px';
                this.element.nativeElement.parentElement.style.bottom = '';
            }

            if ((event.clientX - this._leftStart) !== 0) {
                this.element.nativeElement.parentElement.style.left = (event.clientX - this._leftStart) + 'px';
                this.element.nativeElement.parentElement.style.right = '';
            }

            // Empeche le highlight de selection de texte lorsque l'on bouge le composant
            event.preventDefault();
        }
    }

    @HostListener('touchstart', ['$event'])
    public onTouchStart(event: any) {
        this.md = true;
        this._topStart = event.changedTouches[0].clientY - this.element.nativeElement.parentElement.offsetTop;
        this._leftStart = event.changedTouches[0].clientX - this.element.nativeElement.parentElement.offsetLeft;
    }

    @HostListener('document:touchend')
    public onTouchEnd() {
        this.md = false;
    }

    @HostListener('touchmove', ['$event'])
    public onTouchMove(event: any) {
        if (this.md && this._allowDrag) {

            if ((event.clientY - this._topStart) !== 0) {
                this.element.nativeElement.parentElement.style.top = (event.changedTouches[0].clientY - this._topStart) + 'px';
                this.element.nativeElement.parentElement.style.bottom = '';
            }

            if ((event.clientX - this._leftStart) !== 0) {
                this.element.nativeElement.parentElement.style.left = (event.changedTouches[0].clientX - this._leftStart) + 'px';
                this.element.nativeElement.parentElement.style.right = '';
            }
            event.preventDefault();
        }
    }

    @Input('draggable')
    set allowDrag(value: boolean) {
        this._allowDrag = value;

        // Ajoute un attribut pour selecteur CSS
        if (this._allowDrag)
            this.element.nativeElement.className += ' cursor-draggable';
        else
            this.element.nativeElement.className = this.element.nativeElement.className.replace(' cursor-draggable', '');
    }

    private stickToViewport() {
        if (this.element.nativeElement.parentElement) {
            if (this.element.nativeElement.parentElement.offsetLeft < 0) {
                this.element.nativeElement.parentElement.style.left = '0px';
            }
            if (this.element.nativeElement.parentElement.offsetTop < 0) {
                this.element.nativeElement.parentElement.style.top = '0px';
            }
            if (this.element.nativeElement.parentElement.offsetParent && this.element.nativeElement.parentElement.offsetLeft + this.element.nativeElement.parentElement.clientWidth > this.element.nativeElement.parentElement.offsetParent.clientWidth) {
                this.element.nativeElement.parentElement.style.left = this.element.nativeElement.parentElement.offsetParent.clientWidth - this.element.nativeElement.parentElement.clientWidth + 'px';
            }
            if (this.element.nativeElement.parentElement.offsetParent && this.element.nativeElement.parentElement.offsetTop + this.element.nativeElement.parentElement.clientHeight > this.element.nativeElement.parentElement.offsetParent.clientHeight) {
                this.element.nativeElement.parentElement.style.top = this.element.nativeElement.parentElement.offsetParent.clientHeight - this.element.nativeElement.parentElement.clientHeight + 'px';
            }
        }
    }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/VyQQATNu/0/groupe-dev/nm17/node_modules/nm-socle-application/app/directives/draggable.directive.ts